import { Component, ElementRef, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { EventsService } from '../../shared/Events.service';
import {ElectionService} from '../../shared/election-service/election.service';
// import { FederalLevelPipe, StateLevelPipe, LocalLevelPipe, CityLevelPipe }  from '../../pipes/electionLevels.pipe';

// import { ExpandPanelComponent } from '../../expand-panel/expandpanel.component';
// import { LoadingComponent } from '../../loading/loading.component';
import { SettingsService } from '../../shared/settings/settings.service';
// import {TranslatePipe, TranslateService} from 'ng2-translate/ng2-translate';

const federal_label:string = "Federal";

@Component({
    selector: 'officials-info',
    // templateUrl: 'app/information/electedofficials/electedofficials.component.html',
    template: require('./electedofficials.component.html')
    // directives: [ExpandPanelComponent, LoadingComponent],
    // pipes: [FederalLevelPipe, StateLevelPipe, LocalLevelPipe, CityLevelPipe]
})



export class ElectedOfficialsComponent implements OnInit {

    officialsInfo: Object;
    isElectedOfficialsRetrieved:boolean = false;
    tabActivated:boolean = false;
    appSettings: Object;
    error: any;

    private selectedAddressLocation:Object;

    constructor(private elRef: ElementRef, private _eventsService: EventsService,private _electionService: ElectionService, private _settingsService: SettingsService) { 
        


    }


    ngOnInit() {
              this._eventsService.selectedAddressObject$.subscribe(address => {
         
                //get the current address
                this.selectedAddressLocation = address["addressLocation"];


            }
            
        ); 

        //listen for when a search has been invoked
        this._eventsService.searchInvoked$.subscribe(
            address => {
                //get the current address
                this.selectedAddressLocation = address["addressLocation"];
                this.isElectedOfficialsRetrieved = false;

                this.selectedAddressLocation ? this.getElectedOfficicalsInformation() : console.log("Address location is undefined");

            }

        );

            // Get app settings from settings service      
            this._settingsService.getAppSettings().subscribe(
                settings => { 
                    this.appSettings = settings[0];

                    let currentTabSettings:Object = this.appSettings["widgets"].filter(item => { return item.name === 'Officials'; });
                    this.tabActivated = currentTabSettings[0].activate;
                
                // this.electionServiceURL = this.appSettings["electionServiceURL"];
                },
                err => { this.error = true }
            ); 
            
     
    }

    //get elected officials data
    getElectedOfficicalsInformation() {
         this._electionService
            .getOfficials(this.selectedAddressLocation["X"], this.selectedAddressLocation["Y"])  //getOfficials(this.selectedAddressLocation["X"], this.selectedAddressLocation["Y"])
            .then(officials => {
                 this.officialsInfo = officials
                 this.isElectedOfficialsRetrieved = true;
          
                }
            )
            .catch(error => {
                this.error = error
                console.log(this.error)
            });
    }

    



    // destroy map
    ngOnDestroy() {

    }

}


// WEBPACK FOOTER //
// ./app/information/electedofficials/electedofficials.component.ts